// extracted by mini-css-extract-plugin
export default {"overlay":"cw-z","bodyOpen":"dw-z","content":"ew-z","header":"fw-z","close":"gw-z","closeNoHeading":"hw-z"};